import styled from '@emotion/styled';

export const TagSearchBarContainer = styled.div`
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.gray};
    padding: 16px;
    flex: 1 0 auto;
    height: 68px;
    max-height: 68px;
    position: relative;
    display: flex;
    gap: 8px;
`;
export const TagWrapper = styled.div`
    display: flex;
    column-gap: 8px;
    row-gap: 16px;
    flex-wrap: wrap;  
    position: absolute;
    top: 16px;
    left: 16px;
    right: 40px;
    height: 38px;
    max-height: 38px;
    overflow-y: auto;
    // invisible scrollbar
    &::-webkit-scrollbar {
        width: 0px;
        background: transparent; /* make scrollbar transparent */
    }
`;

export const Tag = styled.div`
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.gray};
    display:flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 16px */
    letter-spacing: 1px;
    min-height: 38px;
`;
